const mistakes = [
  {
    title: "The Beach-Day Passport Trap",
    icon: "ri-water-flash-line",
    description:
      "Clearwater Beach is paradise — but salt water, sand, and humidity are passport killers. Residents often carry passports in beach bags for same-day cruises or ID needs at the marina. A single wave, splash, or forgotten bag in the trunk can warp the cover, blur the photo, or separate the laminate. Once damaged, the passport is invalid for travel.",
    fix: "Store your passport in a waterproof zip bag inside a fireproof home safe — never in a beach bag, car glove box, or boat storage compartment. If you need ID at the marina, use a passport card or driver's license instead.",
  },
  {
    title: "The Spring Training Trip Surprise",
    icon: "ri-calendar-event-line",
    description:
      "Every March, Phillies and Blue Jays fans from Clearwater and Dunedin book post-camp trips to Toronto, London, or the Caribbean. Many assume their passport is 'fine' because they used it last year. But if it expires within six months of your return, airlines and immigration can deny boarding — even to Canada.",
    fix: "Check your passport expiration date the moment you book spring training travel. If it expires within 9 months of your return date, renew immediately. Do not wait until the week before your flight from TPA.",
  },
  {
    title: "The Six-Month Validity Oversight",
    icon: "ri-time-line",
    description:
      "Most Caribbean destinations, Mexico, Costa Rica, and all Schengen European countries require your passport to be valid for 3–6 months beyond your return date. Clearwater travelers booking Caribbean cruises from Tampa or spring break trips to Cancun often discover this rule at check-in — when it is too late.",
    fix: "Always verify the entry requirements of your specific destination, not just 'passport required.' Schengen countries demand 3 months. Most Caribbean islands want 6 months. When in doubt, renew early.",
  },
  {
    title: "The Wrong Passport Photo",
    icon: "ri-image-line",
    description:
      "Clearwater's endless sunshine creates a unique hazard: the 'sunglasses tan line' passport photo. If your face shows uneven tan lines, shadows from a hat, or the photo background is too close to white sand tones, the State Department will reject it. CVS and Walgreens in Clearwater are convenient but do not always catch these issues.",
    fix: "Use a professional passport photo service that knows State Department rules. Avoid photos taken after long beach days. Wear solid-color shirts, no hats, and ensure even indoor lighting with no shadows on the face.",
  },
  {
    title: "The Child Passport Surprise",
    icon: "ri-parent-line",
    description:
      "Child passports (under age 16) are valid for only 5 years — not 10. Clearwater parents who travel frequently for spring break, summer cruises, or Toronto family visits often forget that their child's passport expired years ago. Both parents must also appear in person or submit notarized consent, which adds time most families do not budget for.",
    fix: "Mark your calendar for 4.5 years after your child's passport issue date. Start the renewal process at the 4-year mark. If one parent cannot attend the acceptance facility, get DS-3053 consent forms notarized well in advance.",
  },
  {
    title: "The Form Error Spiral",
    icon: "ri-file-list-3-line",
    description:
      "A single crossed-out line, wrong date format, or missing middle name on DS-11 or DS-82 can delay processing by weeks. Many Clearwater applicants download outdated forms from unofficial websites or use old versions saved on their computers. Handwritten corrections are not accepted.",
    fix: "Always download forms directly from travel.state.gov. Use black ink only. Print single-sided on standard white paper. Triple-check your name matches your birth certificate or driver's license exactly. When using our service, we review every field before submission.",
  },
];

export default function ClearwaterMistakesSection() {
  return (
    <section id="common-mistakes" className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Avoid Delays
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Common Passport Mistakes Clearwater Travelers Make
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Salt water, sand, spring training excitement, and last-minute spring break planning create
            unique traps for Pinellas County passport applicants. Here is what to watch for.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {mistakes.map((m, i) => (
            <div key={i} className="bg-[#F8F9FB] rounded-lg p-6 border border-gray-100 hover:border-[#F6C344]/50 transition-all">
              <div className="w-10 h-10 rounded-lg bg-[#B22222] flex items-center justify-center mb-4">
                <i className={`${m.icon} text-white text-lg`}></i>
              </div>
              <h3 className="font-serif text-base font-bold text-[#1A365D] mb-3">{m.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">{m.description}</p>
              <div className="bg-white rounded-md p-4 border-l-4 border-[#F6C344]">
                <p className="text-[#1A365D] text-xs font-semibold mb-1">How to Avoid It</p>
                <p className="text-gray-600 text-xs leading-relaxed">{m.fix}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}